import React from 'react';
import '../../App.css';

const BookRentals = () => {
  return <h1 className='book-rentals'>Book Rentals</h1>;
}

export default BookRentals;
